import React from 'react';
import { useLocation, Link } from 'react-router-dom';

function OrderConfirmationPage() {
  const location = useLocation();
  const { orderId, orderDetails } = location.state || {};

  if (!orderId) {
    return (
      <div className="container mx-auto p-8 text-center">
        <h1 className="text-2xl mb-4">Order Information Not Found</h1>
        <Link to="/" className="bg-blue-500 text-white px-4 py-2 rounded">
          Return to Home
        </Link>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-8">
      <div className="bg-green-100 border-l-4 border-green-500 p-4 mb-6">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-500" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-green-700">
              Your order has been placed successfully!
            </p>
          </div>
        </div>
      </div>

      <h1 className="text-3xl font-bold mb-6">Order Confirmation</h1>
      <p className="mb-4">Thank you for your order! Your order number is: <span className="font-bold">{orderId}</span></p>
      
      {/* Display order summary using orderDetails */}
      {orderDetails && (
        <div className="bg-white rounded-lg p-6 mb-8 shadow-sm">
          <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
          <div className="mb-4">
            <p className="text-gray-600">Total Amount: <span className="font-bold">${parseFloat(orderDetails.totalAmount).toFixed(2)}</span></p>
            <p className="text-gray-600">Order Date: <span className="font-bold">{new Date().toLocaleDateString()}</span></p>
          </div>
          
          {orderDetails.shippingInfo && (
            <div className="border-t pt-4 mb-4">
              <h3 className="font-medium mb-2">Shipping Information</h3>
              <p>{orderDetails.shippingInfo.firstName} {orderDetails.shippingInfo.lastName}</p>
              <p>{orderDetails.shippingInfo.address}</p>
              <p>{orderDetails.shippingInfo.city}, {orderDetails.shippingInfo.state} {orderDetails.shippingInfo.areacode}</p>
            </div>
          )}
          
          <div className="border-t pt-4 mb-4">
            <h3 className="font-medium mb-2">Payment</h3>
            <p>Card ending in: ****{orderDetails.shippingInfo?.cardNumber?.slice(-4) || '0000'}</p>
          </div>
        </div>
      )}
      
      <div className="flex justify-between mb-8">
        <Link to="/orders" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
          View All Orders
        </Link>
        <Link to="/" className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">
          Continue Shopping
        </Link>
      </div>
    </div>
  );
}

export default OrderConfirmationPage; 